class SignupForm extends HTMLElement {
  constructor() {
    super();
    this.currentStep = -1;
    this.totalSteps = 7;
  }

  connectedCallback() {
    this.initializeEventListeners();
    this.updateProgressLine();
  }

  initializeEventListeners() {
    const form = this.querySelector('form');
    const prevBtn = this.querySelectorAll('[data-prev-button]');
    const nextBtn = this.querySelectorAll('[data-next-button]');
    const submitBtn = this.querySelectorAll('[data-submit-button]');
    const startBtn = this.querySelector('#startBtn');
    const fileUpload = this.querySelector('#fileUpload');
    const fileInput = this.querySelector('#traderProof');
    const welcomeStep = this.querySelector('.welcome-step');

    prevBtn.forEach(btn => btn.addEventListener('click', () => this.navigateStep(-1)));
    nextBtn.forEach(btn => btn.addEventListener('click', () => this.navigateStep(1)));
    submitBtn.forEach(btn => btn.addEventListener('click', () => this.submitForm()));
    startBtn.addEventListener('click', () => {
      welcomeStep.classList.remove('active');
      const progressBar = this.querySelector('.progress-bar');
      progressBar.classList.remove('hidden');
      this.currentStep = 0;
      this.navigateStep(0);
    });

    fileUpload.addEventListener('click', () => fileInput.click());
    fileUpload.addEventListener('dragover', (e) => {
      e.preventDefault();
      fileUpload.classList.add('dragover');
    });
    fileUpload.addEventListener('dragleave', () => {
      fileUpload.classList.remove('dragover');
    });
    fileUpload.addEventListener('drop', (e) => {
      e.preventDefault();
      fileUpload.classList.remove('dragover');
      fileInput.files = e.dataTransfer.files;
      this.updateFileName();
    });
    fileInput.addEventListener('change', () => this.updateFileName());

    form.addEventListener('submit', (e) => e.preventDefault());
  }

  updateFileName() {
    const fileInput = this.querySelector('#traderProof');
    const fileName = this.querySelector('.file-name');
    if (fileInput.files.length > 0) {
      fileName.textContent = fileInput.files[0].name;
    } else {
      fileName.textContent = '';
    }
  }

  updateProgressLine() {
    const progressLine = this.querySelector('.progress-line');
    if (!progressLine.querySelector('.progress-line-fill')) {
      const fill = document.createElement('div');
      fill.className = 'progress-line-fill';
      progressLine.appendChild(fill);
    }
    const fill = progressLine.querySelector('.progress-line-fill');
    const percentage = (this.currentStep / this.totalSteps) * 100;
    fill.style.width = `${percentage}%`;
  }

  navigateStep(direction) {
    const steps = this.querySelectorAll('.form-step');
    const progressSteps = this.querySelectorAll('.progress-step');
    const welcomeStep = this.querySelector('.welcome-step');
    const progressBar = this.querySelector('.progress-bar');

    if (direction < 0 && this.currentStep === 0) {
      welcomeStep.classList.add('active');
      progressBar.classList.add('hidden');
      steps.forEach(step => step.classList.remove('active'));
      progressSteps.forEach(step => step.classList.remove('active'));
      this.currentStep = -1;
      return;
    }

    if (direction > 0 && !this.validateCurrentStep()) {
      return;
    }

    // Update completed states
    progressSteps.forEach((step, index) => {
      if (direction > 0) {
        // When moving forward, mark current step as completed
        if (index === this.currentStep) {
          step.classList.add('completed');
        }
      } else {
        // When moving backward, remove completed state from current step
        if (index === this.currentStep) {
          step.classList.remove('completed');
        }
      }
    });

    this.currentStep += direction;
    
    steps.forEach((step, index) => {
      step.classList.toggle('active', index === this.currentStep);
    });

    progressSteps.forEach((step, index) => {
      step.classList.toggle('active', index === this.currentStep);
    });

    this.updateProgressLine();
  }

  validateCurrentStep() {
    const currentStepElement = this.querySelector(`[data-step="${this.currentStep}"]`);
    const inputs = currentStepElement.querySelectorAll('input, select');
    let isValid = true;

    inputs.forEach(input => {
      if (input.hasAttribute('required') && !input.value) {
        isValid = false;
        this.showError(input, 'This field is required');
      } else {
        this.clearError(input);
      }

      if (input.type === 'tel' && input.value) {
        const phoneRegex = /^\+?[\d\s-]{10,}$/;
        if (!phoneRegex.test(input.value)) {
          isValid = false;
          this.showError(input, 'Please enter a valid phone number');
        }
      }
    });

    return isValid;
  }

  showError(input, message) {
    const formGroup = input.closest('.form-group');
    let errorElement = formGroup.querySelector('.error-message');
    
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'error-message';
      formGroup.appendChild(errorElement);
    }
    
    errorElement.textContent = message;
    input.classList.add('error');
  }

  clearError(input) {
    const formGroup = input.closest('.form-group');
    const errorElement = formGroup.querySelector('.error-message');
    
    if (errorElement) {
      errorElement.remove();
    }
    
    input.classList.remove('error');
  }

  async submitForm() {
    if (!this.validateCurrentStep()) {
      return;
    }

    const formData = new FormData(this.querySelector('form'));
    const response = await fetch('/apps/endpoints-app/form-submissions/public/submit', {
      method: 'POST',
      body: formData
    }).catch(error => {
      console.error('Error submitting form:', error);
    });

    if (!response.ok) {
      alert('Submission failed');
      return;
    }

    this.showSuccessStep();
  }

  showSuccessStep() {
    const successStep = this.querySelector('.success-step');
    successStep.classList.add('active');
    const progressBar = this.querySelector('.progress-bar');
    progressBar.classList.add('hidden');
    this.querySelectorAll('.form-step').forEach(step => step.classList.add('hidden'));
    const steps = this.querySelectorAll('.form-step');
    steps.forEach(step => step.classList.remove('active'));
  }
}

customElements.define('signup-form', SignupForm);
